module.exports = __webpack_public_path__ + "img/e2c2ab90-21dc-4e8f-a392-1b669f5968aa.8e48018e.png";